const miuri    = require('Vendor/miuri.js').miuri;
const Spectrum = require("Vendor/spectrum-colorpicker");

export default class Customiser {
	constructor() {
		this.ui = {
			baseUrl:      $('#js-generator-base-url'),
			borderRadius: $('.js-generator-border-radius'),
			buttonColour: $('.js-generator-button-colour'),
			buttonSize:   $('.js-generator-button-size'),
			buttonText:   $('.js-generator-text'),
			textColour:   $('.js-generator-text-colour'),
			updatable:    $('.js-generator-update'),
		};

		if(!this.ui.baseUrl.length) {
			this.ui.baseUrl = $('#js-generator-base-url-fallback');
		}

		this.initSpectrum();
		this.update();
		this.bindEventHandlers();
	}

	bindEventHandlers() {
		$.each(this.ui, (i,element) => { 
			$(element).on('change', this.update.bind(this));
		});
	};

	// Extracts the user-selected options from the form, using default values if nothing is entered into the input.
	getSettings() {
		let sizes = this.ui.buttonSize.find(':selected');

		return {
			backgroundColour: this.ui.buttonColour.val(),
			borderRadius:     this.ui.borderRadius.val() + 'px',
			buttonText:       (this.ui.buttonText.val() || 'Donate >').replaceAll("<", "&lt;").replaceAll(">", "&gt;"),
			padding:          sizes.data('padding') || '8px 30px',
			fontSize:         sizes.data('fontSize') || '18px',
			textColour:       this.ui.textColour.filter(":checked").data("colour"),
			url:              this.buildUrl(),
		}
	}

	// Builds the URL for the donation button, taking into account any options that have been selected.
	buildUrl() {
		let baseUrl = new miuri(this.ui.baseUrl.val())

		if(this.ui.buttonColour.length){
			baseUrl.query('bc', this.ui.buttonColour.val().substr(1));
			baseUrl.query('br', this.ui.borderRadius.val());
			baseUrl.query('tc', this.ui.textColour.filter(":checked").val());
			baseUrl.query('wl', 1);
		}
		
		return baseUrl.toString()
	}

	// Initialise the plugin we use for colour picking.
	initSpectrum() {
		$('.js-colour-picker').each((i,picker) => {
			let element       = $(picker);
			let initialColour = element.data('initialColour');
			
			element.val(initialColour);

			element.spectrum({
				color: initialColour,
				showInput: true,
				preferredFormat: "hex"
			}).on('dragstop.spectrum', (e, colour) => {
				// Manually set the colour and fire the change event to update the button
				element.spectrum('set', colour.toHexString()).trigger('change');
			});
		});
	}

	// Regex to replace {{ xxx }} where xxx is in the list produced by getSettings
	generateHtml(originalHtml, settings) {
		if(originalHtml.startsWith('http')) return settings.url;
		return (originalHtml || '').replace(/{{ ([^}]+)+ }}/g, (full, key) => { return settings[key] });
	}

	// Loop through the elements that need to be updated (use data-dependency="#element" to set the base value)
	update() {
		console.log("Customiser.update()");
		let settings = this.getSettings();

		this.ui.updatable.each((i,element) => {
			let el        = $(element);
			let baseValue = $(el.data('dependency')).val() || '';
			let newValue  = this.generateHtml(baseValue, settings);
			let elType    = el.prop("tagName");

			// What we update depends on element type
			if(elType == "A"){
				el.attr("href", newValue);
			}
			else if(elType == "INPUT"){
				el.val(newValue);
			}
			else if(elType == "TEXTAREA"){
				el.val(newValue);
				el.html(newValue);
			}
			else {
				el.html(newValue); // Default - e.g. DIV
			}
		});
	}
}
